import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  FaMapMarkerAlt, FaPhoneAlt, FaClock, FaStar,
  FaUser, FaBuilding, FaHandshake, FaChevronRight,
  FaMoneyBillWave, FaRulerCombined, FaIdCard,
  FaChevronLeft, FaImages, FaTimes, FaShieldAlt, FaCalendarCheck,
  FaClipboardList, FaExternalLinkAlt,
  FaChartLine, FaMap
} from "react-icons/fa";
import { QrCode } from "lucide-react";

// مكونات الخريطة
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';

import BackMethods from "../../back_component/BackMethods";
import Establishment from "../../models/Establishment";
import img from "../../1.webp";
import ComplaintForm from "../PublicUsers/ComplaintForm";

// إصلاح أيقونات الخريطة الافتراضية في Leaflet
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

let DefaultIcon = L.icon({
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
  iconSize: [25, 41],
  iconAnchor: [12, 41]
});
L.Marker.prototype.options.icon = DefaultIcon;

export default function EstablishmentDetailsPage({ isPublicView = false }) {
  const navigate = useNavigate();
  const { id } = useParams();
  const { backEnd_request } = BackMethods();

  const [est, setEst] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [showGallery, setShowGallery] = useState(false);
  const [activeTab, setActiveTab] = useState("persons");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const endpoint = isPublicView ? `/public/establishments/${id}` : `/Establishments/${id}`;
        const { data } = await backEnd_request.get(endpoint);
        setEst(new Establishment(data));
        console.log(data);
      } catch (error) {
        setError(error.response?.data || "خطأ في الاتصال بالخادم");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [id, isPublicView]);

  if (loading) return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="spinner-border text-info" role="status"></div>
    </div>
  );

  if (error) return <div className="alert alert-danger m-3 shadow-sm text-center">{error}</div>;
  if (!est) return null;

  const allPhotos = !isPublicView && est?.photos?.length > 0
    ? est.photos.map(p => p.photoUrl)
    : [est.externalPhotoUrl || est?.externalPhoto?.photoUrl || img];

  const nextImg = (e) => { e.stopPropagation(); setCurrentIndex((prev) => (prev + 1) % allPhotos.length); };
  const prevImg = (e) => { e.stopPropagation(); setCurrentIndex((prev) => (prev - 1 + allPhotos.length) % allPhotos.length); };

  return (
    <div className="details-wrapper bg-light pb-5" dir="rtl">
      {/* --- Hero Section --- */}
      <div className="hero-section text-white position-relative">
        <div className="hero-overlay"></div>
        <div className="container position-relative py-3 py-lg-4">
          {/* <button onClick={() => navigate(-1)} className="btn btn-link text-white text-decoration-none mb-3 p-0 back-link">
            <FaChevronRight className="ms-1" /> العودة
          </button> */}
          <button
            onClick={() => navigate(-1)}
            className="btn btn-link text-white text-decoration-none mb-3 p-0 back-link d-flex align-items-center ms-auto ms-lg-0 me-auto"
            style={{ direction: 'ltr' }} // لضمان ظهور السهم على يسار الكلمة
          >
            <FaChevronLeft className="me-1" /> {/* غيّرنا Right إلى Left لتناسب اتجاه العودة */}
            العودة
          </button>
          <div className="row align-items-center g-3">
            <div className="col-12 col-md-4 col-lg-3 d-flex justify-content-center justify-content-md-start">
              <div className="profile-img-container shadow-lg" onClick={() => setShowGallery(true)}>
                <img src={allPhotos[0]} alt={est.name} />
                {allPhotos.length > 1 && (
                  <div className="image-count-overlay"><FaImages className="ms-1" /> {allPhotos.length}</div>
                )}
              </div>
            </div>

            <div className="col-12 col-md-8 col-lg-6 text-center text-md-end">
              <span className="badge bg-info mb-2 px-3 py-2 rounded-pill shadow-sm small">
                {est.facilityType || "منشأة تجارية"}
              </span>
              <h2 className="fw-bold est-title mb-1">{est.name}</h2>
              <p className="opacity-75 small mb-0">
                <FaMapMarkerAlt className="ms-1 text-warning" /> {est.governorate} - {est.city} - {est.district}
              </p>
            </div>

            {!isPublicView && (
              <div className="col-12 col-lg-3">
                <div className="responsive-toolbar">
                  <button className="t-btn" onClick={() => navigate(`/admin/visits?establishment=${id}`)}><FaCalendarCheck /> <span>الزيارات</span></button>
                  <button className="t-btn" onClick={() => navigate(`/admin/violations?establishment=${id}`)}><FaIdCard /> <span>الضبوط</span></button>
                  <button className="t-btn" onClick={() => navigate(`/admin/complaints?establishment=${id}`)}><FaClipboardList /> <span>الشكاوى</span></button>
                  <button className="t-btn" onClick={() => navigate(`/admin/price-survey-report?establishmentUid=${est.fieldUID}`)}><FaChartLine /> <span>سبر الأسعار</span></button>
                  <button className="t-btn" onClick={() => navigate("/admin/generate-uid", { state: { uid: est.fieldUID, id: est.establishmentId } })}><QrCode /> <span>QR طباعة</span></button>
                  <button className="t-btn" onClick={() => navigate("/admin/inspection-mission/create", {
                    state: {
                      fieldUID: est.fieldUID,
                      establishmentName: est.name
                    }
                  })}>
                    <FaShieldAlt /> <span>إسناد مهمة</span>
                  </button>

                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="container mt-4">
        <div className="row g-4">
          {/* الجانب الأيمن */}
          <div className="col-12 col-lg-8">
            <div className="info-card shadow-sm border-0 bg-white p-3 p-md-4 mb-4">
              <h6 className="card-header-modern mb-3"><FaBuilding className="ms-2 text-info" /> بيانات المنشأة</h6>
              <div className="row g-2">
                <div className="col-12 col-sm-6"><DetailItem label="نوع البيع" value={est.salesType} icon={<FaHandshake />} /></div>
                <div className="col-12 col-sm-6"><DetailItem label="الرخصة" value={est.tradeRegistryNumber} icon={<FaIdCard />} /></div>
                <div className="col-12 col-sm-6"><DetailItem label="التقييم" value={isPublicView ? `${est.rating?.avg || 0} / 5` : `${est.ratingOutOfTen} / 10`} icon={<FaStar className="text-warning" />} /></div>
                {!isPublicView && (
                  <div className="col-12 col-sm-6"><DetailItem label="ساعات العمل" value={`${est.openingTime} - ${est.closingTime}`} icon={<FaClock />} /></div>
                )}
              </div>
            </div>

            {!isPublicView && (
              <div className="modern-tabs-card shadow-sm border-0 bg-white overflow-hidden mb-4">
                <div className="d-flex overflow-auto bg-light-soft p-2 custom-scroll-x border-bottom">
                  <button className={`nav-tab-btn ${activeTab === 'persons' ? 'active' : ''}`} onClick={() => setActiveTab('persons')}>الأشخاص ({est.persons?.length || 0})</button>
                  <button className={`nav-tab-btn ${activeTab === 'property' ? 'active' : ''}`} onClick={() => setActiveTab('property')}>العقار</button>
                  <button className={`nav-tab-btn ${activeTab === 'activities' ? 'active' : ''}`} onClick={() => setActiveTab('activities')}>الأنشطة</button>
                </div>
                <div className="tab-content p-3 p-md-4 min-h-200">
                  {activeTab === 'persons' && (
                    <div className="animate-fade-in row g-2">
                      {est.persons?.map((p, i) => (
                        <div key={i} className="col-12 col-md-6">
                          <div className="person-box p-2 border rounded-3 d-flex align-items-center">
                            <FaUser className="text-info ms-2" size={14} />
                            <div className="text-truncate">
                              <div className="fw-bold small text-truncate">{p.firstName} {p.lastName}</div>
                              <div className="text-muted x-small">{p.phone}</div>
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  )}
                  {activeTab === 'property' && (
                    <div className="animate-fade-in row g-2">
                      <div className="col-12 col-sm-6"><DetailItem label="المالك" value={est.propertyOwnerName} icon={<FaUser />} /></div>
                      <div className="col-12 col-sm-6"><DetailItem label="المساحة" value={est.propertyArea} icon={<FaRulerCombined />} /></div>
                      <div className="col-12 col-sm-6"><DetailItem label="الملكية" value={est.propertyType} /></div>
                      <div className="col-12 col-sm-6"><DetailItem label="رأس المال" value={est.estimatedCapital} icon={<FaMoneyBillWave className="text-success" />} /></div>
                    </div>
                  )}
                  {activeTab === 'activities' && (
                    <div className="animate-fade-in d-flex flex-wrap gap-2">
                      {est.activities?.map((a, i) => (
                        <span key={i} className="badge bg-light text-dark border p-2 fw-normal">📌 {a.activityName}</span>
                      ))}
                    </div>
                  )}
                </div>
              </div>
            )}

            {isPublicView && (
              <div className="info-card shadow-sm border-0 bg-white p-3 p-md-4">
                <h6 className="card-header-modern mb-3">تقديم بلاغ</h6>
                <ComplaintForm establishmentId={id} backEnd_request={backEnd_request} />
              </div>
            )}
          </div>

          {/* الجانب الأيسر - الخريطة المصغرة */}
          <div className="col-12 col-lg-4">
            <div className="info-card shadow-sm border-0 bg-white sticky-lg-top" style={{ top: '20px' }}>
              <div className="p-3 border-bottom d-flex justify-content-between align-items-center">
                <h6 className="card-header-modern mb-0 border-0 p-0">
                  <FaMapMarkerAlt className="ms-2 text-danger" /> الموقع الجغرافي
                </h6>
                {est.lat && est.lng && (
                  <a
                    href={`https://www.google.com/maps?q=${est.lat},${est.lng}`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn-google-maps"
                  >
                    <FaExternalLinkAlt /> خرائط جوجل
                  </a>
                )}
              </div>
              {/* الخريطة بداخل إطار (Padding) */}
              <div className="p-3">
                <div className="mini-map-container shadow-sm">
                  {est.lat && est.lng ? (
                    <MapContainer center={[est.lat, est.lng]} zoom={15} style={{ height: '100%', width: '100%' }} zoomControl={false} scrollWheelZoom={false}>
                      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
                      <Marker position={[est.lat, est.lng]} />
                    </MapContainer>
                  ) : (
                    <div className="map-placeholder">
                      <FaMap size={30} className="mb-2 opacity-20" />
                      <span className="x-small fw-bold">الموقع غير محدد بدقة</span>
                    </div>
                  )}
                </div>
                {/* العنوان */}
                <div className="address-details mt-3">
                  <div className="p-3 bg-light rounded-3 border-start border-4 border-info">
                    <p className="x-small text-muted mb-1 fw-bold">العنوان التفصيلي:</p>
                    <p className="small mb-0 text-dark fw-bold">{est.addressText || "لم يتم توفير تفاصيل إضافية"}</p>
                  </div>

                  <div className="mt-3 d-flex flex-column gap-2">
                    <div className="d-flex justify-content-between x-small border-bottom pb-1">
                      <span className="text-muted">المنطقة</span>
                      <span className="fw-bold">{est.district || "غير محدد"}</span>
                    </div>
                    <div className="d-flex justify-content-between x-small">
                      <span className="text-muted">المحافظة</span>
                      <span className="fw-bold">{est.governorate}</span>
                    </div>
                  </div>
                  {est.phone && (
                    <a href={`tel:${est.phone}`} className="mobile-call-btn shadow-sm mt-4">
                      <div className="d-flex align-items-center">
                        <div className="icon-circle ms-2"><FaPhoneAlt size={12} /></div>
                        <span>اتصال سريع: {est.phone}</span>
                      </div>
                      <FaChevronLeft size={10} />
                    </a>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showGallery && (
        <div className="gallery-portal" onClick={() => setShowGallery(false)}>
          <button className="close-portal"><FaTimes /></button>
          <div className="gallery-main" onClick={e => e.stopPropagation()}>
            <img src={allPhotos[currentIndex]} alt="gallery" />
            <div className="portal-nav">
              <button onClick={prevImg}><FaChevronRight /></button>
              <span className="mx-3">{currentIndex + 1} / {allPhotos.length}</span>
              <button onClick={nextImg}><FaChevronLeft /></button>
            </div>
          </div>
        </div>
      )}
      <style>{`
                .details-wrapper { min-height: 100vh; font-family: 'Cairo', sans-serif; background: #f4f7f9; }
                .hero-section { background: #1a2533; position: relative; overflow: hidden; }
                .hero-overlay { position: absolute; inset: 0; background: linear-gradient(180deg, rgba(26,37,51,0.4) 0%, #1a2533 100%); }
                .est-title { font-size: clamp(1.2rem, 4vw, 1.8rem); color: #fff; }
                
                .profile-img-container { 
                    width: 180px; height: 150px; border-radius: 12px; border: 3px solid #fff; 
                    position: relative; overflow: hidden; cursor: pointer; z-index: 5; background: #eee;
                }
                .profile-img-container img { width: 100%; height: 100%; object-fit: cover; }
                .image-count-overlay { position: absolute; bottom: 0; width: 100%; background: rgba(0,0,0,0.6); color: #fff; font-size: 10px; padding: 3px; text-align: center; }

                .responsive-toolbar { display: grid; grid-template-columns: repeat(3, 1fr); gap: 6px; }
                .t-btn { 
                    background: rgba(255,255,255,0.08); border: 1px solid rgba(255,255,255,0.1);
                    color: #fff; padding: 8px 4px; border-radius: 10px; font-size: 10px;
                    display: flex; flex-direction: column; align-items: center; gap: 4px; transition: 0.3s;
                }
                .t-btn:hover { background: #0ea5e9; border-color: #0ea5e9; }

                .info-card { border-radius: 16px; border: 1px solid #edf2f7 !important; }
                .card-header-modern { font-size: 0.9rem; font-weight: 800; color: #334155; border-right: 4px solid #0ea5e9; padding-right: 10px; }
                
                .detail-item { 
                    display: flex; justify-content: space-between; align-items: center;
                    padding: 8px 12px; background: #f8fafc; border-radius: 8px; border: 1px solid #edf2f7;
                }
                .detail-item .lbl { font-size: 11px; color: #64748b; display: flex; align-items: center; gap: 6px; }
                .detail-item .val { font-size: 12px; font-weight: 700; color: #1e293b; }

                .mini-map-container {
                    height: 180px; width: 100%; border-radius: 12px; overflow: hidden;
                    border: 1px solid #eee; background: #f8fafc;
                }
                .map-placeholder {
                    height: 100%; display: flex; flex-direction: column; align-items: center;
                    justify-content: center; color: #94a3b8;
                }

                .btn-google-maps {
                    font-size: 10px; font-weight: 700; color: #0ea5e9; text-decoration: none;
                    background: rgba(14, 165, 233, 0.05); padding: 5px 12px; border-radius: 100px;
                    display: flex; align-items: center; gap: 6px; border: 1px solid rgba(14, 165, 233, 0.1);
                }

                .nav-tab-btn { 
                    background: none; border: none; padding: 8px 16px; color: #64748b; 
                    font-weight: 700; font-size: 13px; white-space: nowrap; border-radius: 8px; transition: 0.3s;
                }
                .nav-tab-btn.active { background: #0ea5e9; color: #fff; box-shadow: 0 4px 10px rgba(14,165,233,0.2); }
                
                .mobile-call-btn { 
                    display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 12px 15px;
                    background: #1e293b; color: #fff; border-radius: 12px; text-decoration: none; font-weight: 600; font-size: 13px;
                }
                .icon-circle { background: rgba(255,255,255,0.1); width: 24px; height: 24px; border-radius: 50%; display: flex; align-items: center; justify-content: center; }

                .x-small { font-size: 10px; }
                .animate-fade-in { animation: fadeIn 0.4s ease-out; }
                @keyframes fadeIn { from { opacity: 0; transform: translateY(8px); } to { opacity: 1; transform: translateY(0); } }

                .gallery-portal { position: fixed; inset: 0; background: rgba(0,0,0,0.95); z-index: 9999; display: flex; align-items: center; justify-content: center; padding: 20px; }
                .gallery-main img { max-width: 100%; max-height: 75vh; border-radius: 8px; box-shadow: 0 0 30px rgba(0,0,0,0.5); }
                .portal-nav { color: #fff; margin-top: 15px; font-weight: 600; }
                .portal-nav button { background: #fff; border: none; padding: 8px 15px; border-radius: 20px; font-size: 14px; }
                .close-portal { position: absolute; top: 20px; right: 20px; background: #ff4d4d; color: white; border: none; width: 35px; height: 35px; border-radius: 50%; }

                @media (max-width: 768px) {
                    .profile-img-container { width: 130px; height: 100px; }
                }
            `}</style>
    </div>
  );
}

function DetailItem({ label, value, icon }) {
  return (
    <div className="detail-item shadow-sm-hover">
      <span className="lbl">{icon} {label}</span>
      <span className="val text-truncate" title={value}>{value || "—"}</span>
    </div>
  );
}